// extracted by mini-css-extract-plugin
module.exports = {"ctrlBtn":"MovieControls_ctrlBtn__3x8Q6"};